/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Adam (Tuannd@rsupport.com)
 *
 * @description
 *
 * @created at Mon Oct 28 2024
 **/
import { useMemo, useState } from "react";

import { useGroup, useSpace } from "@/frameworks/core/API";
import { Environments } from "@/frameworks/libraries/utilities";

const DATABASE_URL = Environments.env<string>("API_DOMAIN");

export default function useGetLogoSrc() {
	const [logoSrc, setLogoSrc] = useState("");

	const spaceAPI = useSpace({
		onSuccess(name) {
			switch (name) {
				case "inquiryWOAuth": {
					const { data } = spaceAPI.inquiryWOAuth.result;
					if (data?.invitePageLogoPath) {
						setLogoSrc(data.invitePageLogoPath);
					}
					break;
				}
			}
		}
	});
	const groupAPI = useGroup({
		onSuccess() {
			const groupInfo = groupAPI.inquiry.inquiryWOAuth.result;
			if (groupInfo.data?.invitePageLogoPath) {
				setLogoSrc(groupInfo.data.invitePageLogoPath);
			}
		}
	});

	const logoUrl = useMemo(() => (logoSrc ? DATABASE_URL + logoSrc : ""), [logoSrc]);

	return { logoUrl };
}
